export const REDIRECT_NAME = 'Redirect'

export const PARENT_LAYOUT_NAME = 'ParentLayout'

export const PAGE_NOT_FOUND_NAME = 'PageNotFound'

export function EXCEPTION_COMPONENT() {
    return import('/@/views/sys/exception/Exception.vue')
}

/**
 * @description: default layout
 */
export function LAYOUT() {
    return import('/@/layouts/default/index.vue')
}

/**
 * @description: parent-layout
 */
export function getParentLayout(_name?: string) {
    return () =>
        new Promise((resolve) => {
            resolve({
                name: _name || PARENT_LAYOUT_NAME,
            })
        })
}
